class HeaderDropdown extends HTMLElement {
  constructor() {
    super();

    this.listeners = [];
    this.currentMode = null;

    this.addL = this.addL.bind(this);
    this.teardown = this.teardown.bind(this);
    this.onResize = this.onResize.bind(this);

    this.searchModal = document.querySelector("[data-search-modal]");
    this.searchModalButton = document.querySelector(
      "[data-search-modal-button]"
    );
    this.searchBar = this.searchModal.querySelector("input");
    this.headerUnderlay = document.querySelector("[data-header-underlay]");

    this.onWindowBlur = this.onWindowBlur.bind(this);
    window.addEventListener("blur", this.onWindowBlur);

    this.searchModalOpenState = false;
    this.underlayTween = null;

    this.searchModalButton.addEventListener("click", () => {
      if (this.searchModalOpenState) {
        this.closeSearchModal();
        return;
      }
      this.openSearchModal();
    });

    CustomEase.create("menu-hover", "M0,0 C0.5,0 0.5,1 1,1");

    this.cart = document.querySelector("cart-drawer");

    window.addEventListener("resize", this.onResize);
  }

  connectedCallback() {
    this.setMode();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
    this.teardown();
  }

  onWindowBlur() {
    // kill underlay altijd
    if (this.underlayTween) {
      this.underlayTween.kill();
      this.underlayTween = null;
    }

    if (this.headerUnderlay) {
      gsap.killTweensOf(this.headerUnderlay);
      this.headerUnderlay.style.opacity = 0;
      this.headerUnderlay.style.display = "none";
    }

    // sluit open UI-states
    if (this.searchModalOpenState) {
      this.closeSearchModal();
    }

    document.querySelectorAll("[data-menu-content]").forEach((c) => {
      gsap.killTweensOf(c);
      gsap.set(c, { clearProps: "all" });
      c.style.display = "none";
    });
  }


  addL(el, event, handler) {
    el.addEventListener(event, handler);
    this.listeners.push(() => el.removeEventListener(event, handler));
  }

  teardown() {
    this.listeners.forEach((fn) => fn());
    this.listeners = [];

    // Panel states altijd resetten bij mode-switch
    document.querySelectorAll("[data-menu-content]").forEach((c) => {
      gsap.killTweensOf(c);
      gsap.set(c, { clearProps: "all" });
      c.style.display = "none";
    });

    if (this.headerUnderlay) {
      if (this.underlayTween) {
        this.underlayTween.kill();
        this.underlayTween = null;
      }
      gsap.killTweensOf(this.headerUnderlay);
      this.headerUnderlay.style.opacity = 0;
      this.headerUnderlay.style.display = "none";
    }

    this.style.display = "";
    gsap.set(this, { clearProps: "all" });
    document.querySelector("[data-menu-button]").textContent =
      window.translations.menu;
  }

  onResize() {
    const desktop = window.innerWidth >= 1100;
    if (desktop && this.currentMode !== "desktop") this.setMode();
    if (!desktop && this.currentMode !== "mobile") this.setMode();
  }

  setMode() {
    this.teardown();

    if (window.innerWidth >= 1100) {
      this.setupDesktopHover();
      this.currentMode = "desktop";
    } else {
      this.setupMobile();
      this.currentMode = "mobile";
    }
  }

  /* ------------------------------------------------------
       DESKTOP
       ------------------------------------------------------ */

  setupDesktopHover() {
    let activeItem = null;
    let enteringItem = null; // Track which item we're currently entering
    let played = false;
    let lastIndex = 0;

    const durationContent = 0.35;
    const distanceContent = 12;
    const self = this;

    const menuLinkItems = [
      ...document.querySelectorAll("[data-menu-link-item]"),
    ];

    menuLinkItems.forEach((item) => {
      this.addL(item, "pointerenter", () => onMenuLinkHover(item));
      this.addL(item, "pointerleave", () => onMenuLinkLeave(item));
    });

    function onMenuLinkHover(item) {
      gsap.killTweensOf(menuLinkItems);

      menuLinkItems.forEach((i) => {
        gsap.to(i, {
          color: color.gray300,
          duration: 0.2,

          ease: "power2.out",
        });
      });

      gsap.to(item, {
        color: color.primary,
        duration: 0.2,
        ease: "power2.out",
      });
    }

    function onMenuLinkLeave(item) {
      gsap.killTweensOf(menuLinkItems);

      menuLinkItems.forEach((i) => {
        gsap.to(i, {
          color: color.gray600,

          duration: 0.2,
          ease: "power2.out",
        });
      });
    }

    const menuItems = [...document.querySelectorAll("[data-menu-item]")];

    menuItems.forEach((item, index) => {
      this.addL(item, "pointerenter", () => onEnter(item, index));
      this.addL(item, "pointerleave", (e) => onLeave(item, e));
    });

    function resetElement(el) {
      gsap.killTweensOf(el);
      gsap.set(el, { clearProps: "all" });
    }

    async function onEnter(item, index) {
      enteringItem = item;

      if (self.cart && self.cart.isOpen) {
        self.cart.close();

        await new Promise((resolve) => setTimeout(resolve, 120));

        // Check if we're still hovering this item after the delay
        // If enteringItem changed or is null, we've moved to another item or left
        if (enteringItem !== item) {
          return;
        }
      }

      if (self.searchModal && self.searchModalOpenState) {
        self.closeSearchModal();

        await new Promise((resolve) => setTimeout(resolve, 120));
        // Check again after closing search modal
        if (enteringItem !== item) {
          return;
        }
      }

      if (self.headerUnderlay) {
        self.headerUnderlay.style.display = "block";

        if (self.underlayTween) {
          self.underlayTween.kill();
        }
        self.underlayTween = gsap.to(self.headerUnderlay, {
          opacity: 0.3,
          duration: 0.12,
          ease: "menu-hover",
        });
      }

      const menuContent = item.querySelector("[data-menu-content]");
      if (!menuContent) return;

      const inner = menuContent.firstElementChild;
      const children = [...inner.children];

      if (activeItem && activeItem !== item) {
        const prev = activeItem.querySelector("[data-menu-content]");
        if (prev) {
          resetElement(prev);
          prev.style.display = "none";
        }
      }

      resetElement(menuContent);
      children.forEach(resetElement);
      menuContent.style.display = "block";

      if (!played) {
        played = true;
        lastIndex = index;

        gsap.fromTo(
          menuContent,
          { y: distanceContent, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: durationContent,
            ease: "power3.out",
          }
        );
      } else {
        const direction = lastIndex < index ? -40 : 40;
        lastIndex = index;

        gsap.fromTo(
          children,
          { x: direction, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 0.2,
            ease: "power2.out",
          }
        );
      }

      activeItem = item;
      enteringItem = null; // Clear entering flag once we've successfully entered
    }

    function onLeave(item, e) {
      // Clear entering flag if we're leaving the item that was being entered
      if (enteringItem === item) {
        enteringItem = null;
      }

      const hoveredEl = document.elementFromPoint(e.clientX, e.clientY);
      const hoveringAnother = menuItems.some((i) => i.contains(hoveredEl));

      const menuContent = item.querySelector("[data-menu-content]");
      if (!menuContent) return;

      const inner = menuContent.firstElementChild;
      const children = [...inner.children];

      if (hoveringAnother) {
        resetElement(menuContent);
        children.forEach(resetElement);
        menuContent.style.display = "none";
        return;
      }

      gsap.killTweensOf(menuContent);

      gsap.to(menuContent, {
        y: distanceContent,
        opacity: 0,
        duration: durationContent,
        ease: "power3.out",
        onComplete: () => {
          menuContent.style.display = "none";
          gsap.set(menuContent, { clearProps: "all" });
        },
      });

      activeItem = null;

      // Only hide underlay if search modal is not open
      if (self.headerUnderlay && !self.searchModalOpenState) {
        if (self.underlayTween) {
          self.underlayTween.kill();
        }
        self.underlayTween = gsap.to(self.headerUnderlay, {
          opacity: 0,
          duration: 0.12,
          ease: "menu-hover",
          onComplete: () => {
            self.headerUnderlay.style.display = "none";
            played = false;
          },
        });
      } else {
        played = false;
      }
    }
  }

  /* ------------------------------------------------------
       MOBILE 
       ------------------------------------------------------ */

  setupMobile() {
    const self = this;

    let menuOpenState = false;
    let menuButton = document.querySelector("[data-menu-button]");

    this.addL(menuButton, "click", () => {
      onMenuButtonClick();
    });

    const headerMenu = this;

    function onMenuButtonClick() {
      if (menuOpenState) {
        closeMenu();
        closeAllMenuContents();
        menuOpenState = false;
        menuButton.textContent = window.translations.menu;
      } else {
        openMenu();
        menuOpenState = true;
        menuButton.textContent = window.translations.close;
      }
    }

    function openMenu() {
      headerMenu.style.display = "flex";

      gsap.fromTo(
        headerMenu,
        { y: "10%", opacity: 0 },
        { y: 0, opacity: 1, duration: 0.25, ease: "power4.out" }
      );
    }

    function closeMenu() {
      gsap.to(headerMenu, {
        y: "10%",
        opacity: 0,
        duration: 0.25,
        ease: "power4.out",
        onComplete: () => {
          headerMenu.style.display = "none";
        },
      });
    }

    const menuItems = [...document.querySelectorAll("[data-menu-item]")];

    menuItems.forEach((item) => {
      const firstLink = item.querySelector("a");
      const goBackButton = item.querySelector("[data-go-back]");

      if (firstLink) {
        this.addL(firstLink, "click", (e) => {
          e.preventDefault();
          onMenuItemClick(item);
        });
      }

      if (goBackButton) {
        this.addL(goBackButton, "click", (e) => {
          e.preventDefault();
          onGoBackClick(item);
        });
      }
    });

    function onMenuItemClick(item) {
      const menuContent = item.querySelector("[data-menu-content]");
      menuContent.style.display = "block";

      gsap.fromTo(
        menuContent,
        { opacity: 0 },
        { opacity: 1, duration: 0.25, ease: "power4.out" }
      );
    }

    function onGoBackClick(item) {
      const menuContent = item.querySelector("[data-menu-content]");

      gsap.to(menuContent, {
        opacity: 0,
        duration: 0.25,
        ease: "power4.out",
        onComplete: () => {
          menuContent.style.display = "none";
        },
      });
    }

    function closeAllMenuContents() {
      menuItems.forEach((item) => {
        const menuContent = item.querySelector("[data-menu-content]");
        gsap.killTweensOf(menuContent);
        gsap.set(menuContent, { clearProps: "all" });
        if (menuContent) menuContent.style.display = "none";
      });

      // close the cart if it is open
      if (self.cart && self.cart.isOpen) {
        self.cart.close();
      }
    }

    // search functionality moved to class method
  }

  async openSearchModal() {
    const self = this;

    if (self.cart && self.cart.isOpen) {
      this.cart.close();

      await new Promise((resolve) => setTimeout(resolve, 120));
    }

    // Show header underlay when search modal opens
    if (this.headerUnderlay) {
      this.headerUnderlay.style.display = "block";

      if (this.underlayTween) {
        this.underlayTween.kill();
      }
      this.underlayTween = gsap.to(this.headerUnderlay, {
        opacity: 0.3,
        duration: 0.12,
        ease: "menu-hover",
      });
    }

    this.searchModal.style.display = "block";

    gsap.fromTo(
      this.searchModal,
      { opacity: 0, y: "12" },
      { opacity: 1, y: "0", duration: 0.25, ease: "menu-hover" }
    );

    this.searchBar.focus();

    this.setAttribute("data-cartopen", "true");

    let closeSetupState = false;

    if (closeSetupState === false) {
      this.openScrollY = window.scrollY;
      if (this.cartScrollHandler) {
        document.removeEventListener("scroll", this.cartScrollHandler);
      }
      this.searchModalScrollHandler = () => {
        if (!this.searchModalOpenState) {
          document.removeEventListener("scroll", this.cartScrollHandler);
          return;
        }

        if (Math.abs(window.scrollY - this.openScrollY) > 120) {
          this.closeSearchModal();
          document.removeEventListener("scroll", this.cartScrollHandler);
        }
      };
      document.addEventListener("scroll", this.searchModalScrollHandler);

      closeSetupState = true;
    }

    this.searchModalOpenState = true;

    const closeSearchModalButton = this.searchModal.querySelector(
      "[data-close-search-modal]"
    );
    if (closeSearchModalButton) {
      closeSearchModalButton.addEventListener("click", () => {
        this.closeSearchModal();
      });
    }

    this.outsideClickHandler = (e) => {
      const predictiveSearch = this.querySelector("predictive-search");
      if (!predictiveSearch) return;

      if (!predictiveSearch.contains(e.target)) {
        this.closeSearchModal();
        document.removeEventListener("click", this.outsideClickHandler, true);
      }
    };

    document.addEventListener("click", this.outsideClickHandler, true);
  }

  closeSearchModal() {
    if (this.outsideClickHandler) {
      document.removeEventListener("click", this.outsideClickHandler, true);
    }

    if (this.searchModal) {
      gsap.to(this.searchModal, {
        opacity: 0,
        y: "20",
        duration: 0.25,
        ease: "menu-hover",
        onComplete: () => {
          this.searchModal.style.display = "none";
          gsap.set(this.searchModal, { clearProps: "all" });
        },
      });
    }

    if (this.headerUnderlay && this.currentMode === "desktop") {
      const activeMenuContent = document.querySelector(
        "[data-menu-content][style*='display: block']"
      );

      if (!activeMenuContent) {
        if (this.underlayTween) {
          this.underlayTween.kill();
        }
        this.underlayTween = gsap.to(this.headerUnderlay, {
          opacity: 0,
          duration: 0.12,
          ease: "menu-hover",
          onComplete: () => {
            this.headerUnderlay.style.display = "none";
          },
        });
      }
    } else if (this.headerUnderlay && this.currentMode !== "desktop") {
      if (this.underlayTween) {
        this.underlayTween.kill();
      }
      this.underlayTween = gsap.to(this.headerUnderlay, {
        opacity: 0,
        duration: 0.12,
        ease: "menu-hover",
        onComplete: () => {
          this.headerUnderlay.style.display = "none";
        },
      });
    }

    this.searchBar.blur();
    this.setAttribute("data-cartopen", "false");
    this.searchModalOpenState = false;
  }
}

customElements.define("header-dropdown", HeaderDropdown);
